import React from 'react'

type ContentCardProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

const ContentCard = React.forwardRef<HTMLDivElement, ContentCardProps>(
  ({ className = '', children, ...props }, ref) => (
    <div
      ref={ref}
      className={`rounded-md border border-gray-light p-10 max-w-[875px] h-[550px] overflow-hidden bg-cream shadow-subtle ${className}`}
      {...props}
    >
      {children}
    </div>
  ),
)

ContentCard.displayName = 'ContentCard'

export default ContentCard
